"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceForJob = void 0;
const typeorm_1 = require("typeorm/browser");
const base_job_service_1 = require("../base-job-service");
const translatable_string_1 = require("../translatable-string");
const job_view_1 = require("./job-view");
let ServiceForJob = class ServiceForJob extends base_job_service_1.BaseJobService {
};
__decorate([
    (0, typeorm_1.PrimaryColumn)('character varying', {
        nullable: false,
        length: 18,
        name: 'sfid',
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'api_id__c',
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "apiId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'name',
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'customer_needs__c',
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "customerNeeds", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'quantity__c',
    }),
    __metadata("design:type", Number)
], ServiceForJob.prototype, "quantity", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'tage_bis_zur_finalisierung_sla__c',
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "daysUntilFinalizationSla", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'tech_support_url__c',
        length: 255,
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "techSupportUrl", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'technischer_support__c',
        length: 255,
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "technischerSupport", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'installationsanleitung__c',
        length: 255,
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "installGuide", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'material__c',
        length: 4099,
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "material", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'werkzeug__c',
        length: 4099,
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "werkzeug", void 0);
__decorate([
    (0, typeorm_1.Column)('text', {
        name: 'not_part_of_service__c',
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "notPartOfService", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'vor__c',
    }),
    __metadata("design:type", Number)
], ServiceForJob.prototype, "assemblyTime", void 0);
__decorate([
    (0, typeorm_1.Column)((type) => translatable_string_1.TranslatableString, {
        prefix: 'description',
    }),
    __metadata("design:type", translatable_string_1.TranslatableString)
], ServiceForJob.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)((type) => translatable_string_1.TranslatableString, {
        prefix: 'hints',
    }),
    __metadata("design:type", translatable_string_1.TranslatableString)
], ServiceForJob.prototype, "hints", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'unit_measure__c',
        length: 255,
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "unitMeasure", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'is_remote__c',
    }),
    __metadata("design:type", Boolean)
], ServiceForJob.prototype, "isRemote", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'async_appointment__c',
    }),
    __metadata("design:type", Boolean)
], ServiceForJob.prototype, "asyncAppointment", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'is_customer_sign_required__c',
    }),
    __metadata("design:type", Boolean)
], ServiceForJob.prototype, "isCustomerSignRequired", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'is_planning__c',
    }),
    __metadata("design:type", Boolean)
], ServiceForJob.prototype, "isPlanning", void 0);
__decorate([
    (0, typeorm_1.Column)('bigint', {
        nullable: true,
        name: 'sort_index',
    }),
    __metadata("design:type", Number)
], ServiceForJob.prototype, "sortIndex", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'planning_service__c',
        length: 255,
    }),
    __metadata("design:type", String)
], ServiceForJob.prototype, "serviceType", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp', {
        nullable: false,
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], ServiceForJob.prototype, "createdDate", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)((type) => job_view_1.JobView, (jobView) => jobView.services),
    (0, typeorm_1.JoinColumn)({
        name: 'sfj_job_sfid',
    }),
    __metadata("design:type", job_view_1.JobView)
], ServiceForJob.prototype, "job", void 0);
ServiceForJob = __decorate([
    (0, typeorm_1.Entity)('srvice__c', { schema: 'public', synchronize: false })
], ServiceForJob);
exports.ServiceForJob = ServiceForJob;
//# sourceMappingURL=service-for-job.js.map